import { useGetPublicToys } from '@hooks/TRPC_Hooks/useGetToys';
import React, { FC, useState } from 'react';
import s from './artistToysSlider.module.scss';
import 'swiper/css/thumbs';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import { OptimizedImage } from '@components/OptimizedImage/OptimizedImage';
type ArtistToysSliderProps = {
  artistId?: number;
};
export const ArtistToysSlider: FC<ArtistToysSliderProps> = ({
  artistId
}) => {
  const {
    data: toys
  } = useGetPublicToys({
    limit: 3,
    sort: 'newest',
    artist: artistId as number
  }, {
    enabled: !!artistId
  });
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const data = toys?.items ?? [];
  if (!artistId) return null;
  return <div className={s.artistToysSlider} data-sentry-component="ArtistToysSlider" data-sentry-source-file="ArtistToysSlider.tsx">
            {data.length ? <Swiper spaceBetween={10} thumbs={{
      swiper: thumbsSwiper
    }} modules={[FreeMode, Navigation, Thumbs]} className={s.artistToysSlider__swiper}>
                    {data.map(({
        id,
        imageid,
        name
      }, i) => <SwiperSlide className={s.artistToysSlider__slide} key={`slide_${i}`}>
                                <OptimizedImage key={id} alt={name} fill style={{
          objectFit: 'contain'
        }} boxClassName={s.artistToysSlider__image} path={'/toys/cards'} cdnId={imageid} />
                            </SwiperSlide>)}
                </Swiper> : null}

            {data.length ? <Swiper className={s.artistToysSlider__thumbmnail}
    //@ts-ignore 
    onSwiper={swiper => swiper && setThumbsSwiper(swiper)} slidesPerView={data.length} freeMode={true} modules={[FreeMode, Thumbs]} wrapperClass={s.artistToysSlider__thumbmnail}>
                    {data.map(({
        id,
        imageid,
        name
      }, i) => <SwiperSlide className={s.artistToysSlider__thumb} key={`slide_${i}`}>
                                <OptimizedImage key={id} alt={name} fill boxClassName={s.artistToysSlider__image} path={'/toys/cards'} cdnId={imageid} />
                            </SwiperSlide>)}
                </Swiper> : null}
        </div>;
};